import i18n from '@/i18n';

const SUPPORTED_LANGUAGES = ['en', 'es'];
const DEFAULT_LANGUAGE = 'en';

/**
 * Internationalization Utility - Handles all language switching logic
 * Components don't need to know about language changes
 */
export class InternationalizationUtility {
  private static listeners: Set<(language: string) => void> = new Set();

  /**
   * Changes language and notifies all listeners
   */
  static async changeLanguage(targetLanguage: string): Promise<boolean> {
    const languageToUse = SUPPORTED_LANGUAGES.includes(targetLanguage)
      ? targetLanguage
      : DEFAULT_LANGUAGE;

    if (i18n.language !== languageToUse) {
      await i18n.changeLanguage(languageToUse);
      this.notifyListeners(languageToUse);
      return true;
    }
    return false;
  }

  /**
   * Subscribe to language changes
   */
  static subscribe(listener: (language: string) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  /**
   * Get current language
   */
  static getCurrentLanguage(): string {
    return i18n.language;
  }

  /**
   * Get supported languages
   */
  static getSupportedLanguages(): string[] {
    return [...SUPPORTED_LANGUAGES];
  }

  private static notifyListeners(language: string): void {
    this.listeners.forEach(listener => listener(language));
  }
}
